import { type Component, For, Show } from 'solid-js'
import Badge from '~/components/Badge'
import Button from '~/components/Button'
import Icon from '~/components/Icon'

export interface MediosTabPropsType {
  images: () => string[]
  handleImages: (files: FileList | null) => void
  removeImage: (index: number) => void
  moveImageFirst: (index: number) => void
}

/** Pestaña Medios: galería de imágenes incrustadas (data URI, sin almacenamiento de ficheros). */
const MediosTab: Component<MediosTabPropsType> = props => {
  return (
    <div class="space-y-4">
      <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        <For each={props.images()}>
          {(image, index) => (
            <div class="group relative aspect-square rounded-lg border border-border bg-surface-muted overflow-hidden">
              <img src={image} alt={`Imagen ${index() + 1}`} class="size-full object-contain" />
              <Show when={index() === 0}>
                <span class="absolute top-1 left-1">
                  <Badge color="primary" size="sm">
                    Principal
                  </Badge>
                </span>
              </Show>
              <div class="absolute inset-x-0 bottom-0 flex justify-center gap-1 bg-surface/90 p-1 opacity-0 transition-opacity group-hover:opacity-100">
                <Show when={index() !== 0}>
                  <Button size="sm" variant="text" color="default" icon="material-symbols-light:star-outline" tooltip="Hacer principal" onClick={() => props.moveImageFirst(index())} />
                </Show>
                <Button size="sm" variant="text" color="danger" icon="material-symbols-light:delete-outline" tooltip="Quitar" onClick={() => props.removeImage(index())} />
              </div>
            </div>
          )}
        </For>

        <label class="flex aspect-square cursor-pointer flex-col items-center justify-center gap-2 rounded-lg border-2 border-dashed border-border text-foreground-subtle transition-colors hover:border-primary hover:text-primary">
          <Icon icon="material-symbols-light:add-photo-alternate-outline" size={32} />
          <span class="text-xs">Añadir</span>
          <input
            type="file"
            accept="image/png,image/jpeg,image/webp,image/svg+xml"
            multiple
            class="sr-only"
            onClick={e => {
              e.currentTarget.value = ''
            }}
            onChange={e => props.handleImages(e.currentTarget.files)}
          />
        </label>
      </div>

      <p class="text-xs text-foreground-subtle">PNG, JPG, WEBP o SVG, hasta 1 MB cada una. La primera es la que se ve en el listado.</p>
    </div>
  )
}

export default MediosTab
